import { useMutation } from "react-query";
import { consentToSupplierContact } from "../../../services/business";

export const useConsentToSupplierContact = () => {
  return useMutation((data) => consentToSupplierContact(data));
};
